import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-24 md:py-32 px-4 relative overflow-hidden border-t border-border" data-id="element-1">
      {/* Subtle background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-[800px] h-[400px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-2" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="bg-surface border border-border rounded-3xl p-8 md:p-16 shadow-2xl" data-id="element-4">
          <h2 className="text-2xl md:text-3xl font-medium text-white mb-8" data-id="element-5">
            Agenda tu llamada estratégica gratuita
          </h2>
          <Button href="https://calendar.app.google/PYPdcRoYne7QrNJA7" className="w-full md:w-auto text-sm md:text-base" data-id="element-6">
            QUIERO CLIENTES QUE PAGUEN MIS PRECIOS REALES
          </Button>
        </motion.div>
      </div>
    </section>;
}